import { Column } from "../../../components/TablePaginated/TablePaginated";

export const TableHeaderBalanceColumns: Column[] = [
  {
    label: "Cliente",
    id: "customer",
    align: "left",
    showIcon: false,
    sortable: true,
  },
  {
    label: "Filial",
    id: "subsidiary",
    align: "left",
    showIcon: false,
    sortable: true,
  },
  {
    label: "CNPJ",
    id: "cnpj",
    align: "left",
    showIcon: false,
    sortable: true,
  },
  {
    label: "Produto",
    id: "product",
    align: "left",
    showIcon: false,
    sortable: true,
  },
  {
    label: "Modalidade",
    id: "mod",
    align: "center",
    showIcon: false,
    sortable: true,
  },
  {
    label: "Cota Mês",
    id: "quota",
    align: "right",
    showIcon: false,
    sortable: true,
  },
  {
    label: "Cota Atualizada",
    id: "finalQuota",
    align: "right",
    showIcon: false,
    sortable: true,
  },
  {
    label: "Volume faturado",
    id: "stated",
    align: "right",
    showIcon: false,
    sortable: true,
  },
  {
    label: "Saldo",
    id: "balance",
    align: "right",
    showIcon: false,
    sortable: true,
  },
  { label: "", id: "icon", align: "center" },
];
